<script lang="ts">
  import {t} from './i18n'
  import notFound from '../images/not-found.gif'
</script>

<div class="row">
  <div class="simple_block">
    <h1>{t.not_found.title}</h1>
    <div class="simple__content">
      <p>{t.not_found.description}</p>
      <img class="not-found" src={notFound} alt="Not Found" />
    </div>
  </div>
</div>